/* eslint-disable no-secrets/no-secrets */
import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import styles from '../../../SPEventLiabilityStyles.module.scss'
import metadata from './EventInformationComponent.metadata.json5';
import EventLocComponent from '../EventLocation/EventLocComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function EventInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('EventInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const translator = useTranslator()

    const getAvailValuesofDurOfEve = useCallback(() => {
        const availableValues = _.get(modelVM, 'durOfEve13.aspects.availableValues[0].typelist.filters')
        let result = []

        if (_.get(modelVM, 'catOfEve4.value.code') === "BooKio") {
            result = availableValues.filter((typecode) => typecode.name === 'BoothDuration')
        } else {
            result = availableValues.filter((typecode) => typecode.name === 'NonBooth')
        }

        if (_.isEmpty(result)) {
            return []
        }

        const res = result[0]?.codes?.map((typeCode) => ({
            code: typeCode.code,
            name: translator({
                id: typeCode.name,
                defaultMessage: typeCode.name
            })
        }))

        return res;
    }, [modelVM, translator])

    const isLiquorDetailsVisible = () => _.get(submissionVM, 'lobData.speLinLine.coverables.eventLiaCoverable.productCoverageSelection.wilAnyAlcBeSerConAt5.value') !== undefined
        && _.get(submissionVM, 'lobData.speLinLine.coverables.eventLiaCoverable.productCoverageSelection.wilAnyAlcBeSerConAt5.value') === true
        && _.get(submissionVM, 'lobData.speLinLine.coverables.eventLiaCoverable.productCoverageSelection.doYouReqLiqLia6.value') !== undefined
        && _.get(submissionVM, 'lobData.speLinLine.coverables.eventLiaCoverable.productCoverageSelection.doYouReqLiqLia6.value')  === true


// eslint-disable-next-line react-hooks/exhaustive-deps
const overrideProps = {
    '@field': {
        showRequired: true,
        labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
    },
    eventLocComponent: {
        data: modelVM.pslspeEveInfEveLoc,
        updateWizardData,
        submissionVM,
        eventLocPath: `${pathUpdated}.pslspeEveInfEveLoc`
    },
    ifYesForHowManYea9: {
        visible: _.get(modelVM, 'hasTheEveBeeHelBef8.value') !== undefined &&_.get(modelVM, 'hasTheEveBeeHelBef8.value')
    },
    durOfEve13: {
        availableValues: getAvailValuesofDurOfEve()
    },
    typOfMus32: {
        visible: _.get(modelVM, 'wilTheBeMusAtTheEve31.value') !== undefined &&  (_.get(modelVM, 'wilTheBeMusAtTheEve31.value.code') === 'Dj' || _.get(modelVM, 'wilTheBeMusAtTheEve31.value.code') === 'LivEnt')
    },
    ifOthPleDes34: {
        visible: _.get(modelVM, 'whoWilProSecAtTheEve33.value.code') === 'Oth'
    },
    infOnPotInj36: {
        visible: _.get(modelVM, 'areYouConAnyDemThaCou35.value') !== undefined && _.get(modelVM, 'areYouConAnyDemThaCou35.value')
    },
    ifOthPleDes44: {
        visible: isLiquorDetailsVisible() && _.get(modelVM, 'whoIsInChaOfTheSer43.value.code') === 'Oth'
    },
    liquorDetails: {
        visible: isLiquorDetailsVisible()
    },
    estLiqRecForTheEntEve40: {
        visible: isLiquorDetailsVisible()
    },
    wheReqByLawHavYouObt41: {
        visible: isLiquorDetailsVisible()
    },
    liqLicNum42: {
        visible: isLiquorDetailsVisible()
    },
    whoIsInChaOfTheSer43: {
        visible: isLiquorDetailsVisible()
    },
};


const resolvers = {
    resolveCallbackMap: {
        onValidate
    },
    resolveComponentMap: {
        eventLocComponent: EventLocComponent
    },
    resolveClassNameMap: styles
};

const readValue = useCallback(
    (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
    [overrideProps, pathUpdated, submissionVM]
);

const handleValueChange = useCallback(
    (value, changedPath) => {

        if(changedPath === 'estLiqRecForTheEntEve40' && value?.amount?.toString()?.length > 10) {
            return;
        }

        const fullPath = `${pathUpdated}.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);

        updateWizardData(submissionVM);
    },
    [pathUpdated, submissionVM, updateWizardData]
);

return (
    <ViewModelForm
        uiProps={metadata.componentContent}
        model={modelVM}
        resolveValue={readValue}
        overrideProps={overrideProps}
        onValidationChange={onValidate}
        onValueChange={handleValueChange}
        callbackMap={resolvers.resolveCallbackMap}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
    />
);


}

EventInformationComponent.propTypes = wizardProps;
export default withRouter(EventInformationComponent);
